var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m409.437 327.054 89.131-86.881c26.304-25.641 11.789-70.313-24.563-75.596l-123.176-17.898-55.086-111.616c-16.257-32.94-63.229-32.94-79.486 0l-55.086 111.616-123.176 17.898c-36.352 5.282-50.867 49.955-24.562 75.596l89.131 86.881-21.042 122.679c-6.21 36.205 31.792 63.814 64.306 46.721L256 438.533l110.172 57.921c32.514 17.094 70.515-10.516 64.306-46.721zM271 203.5h30v30h-30zm-60 0h30v30h-30zm45 135c-41.355 0-75-33.645-75-75h30c0 24.813 20.187 45 45 45s45-20.187 45-45h30c0 41.355-33.645 75-75 75z",
    fill: "#9d8f8f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 332h30v30h-30zM482 392h30v30h-30zM30 332h30v30H30zM0 392h30v30H0zM45 45h30v30H45zM105 75h30v30h-30zM437 45h30v30h-30zM377 75h30v30h-30z",
    fill: "#9d8f8f",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/grayStar.cd1e68c2a18c4547b879fbae4da12f71.svg";
export { ForwardRef as ReactComponent };